<template>
  <div class="form-group select year-selector">
    <AppSelect
      v-model="selected"
      :options="years"
      :select2-options="select2Options"
    ></AppSelect>
  </div>
</template>

<script>
import VModelCompat from '~/mixins/v_model_compat';

export default {
  name: 'AppYearPicker',
  mixins: [VModelCompat],
  props: {
    startYear: {
      default: () => moment().subtract(1, 'year').year(),
    },
    stopYear: {
      default: () => moment().add(1, 'year').year(),
    },
    // Vue 3 v-model. Declared so the parent binding is a prop instead of a fallthrough attribute.
    modelValue: {
      default: undefined,
    },
    value: {
      default: () => moment().year(),
    },
  },
  emits: ['input', 'update:modelValue'],
  data() {
    return {
      select2Options: {
        allowClear: false,
        multiple: false,
        templateResult: this.yearTemplate,
        width: '100%',
      },
    };
  },
  computed: {
    years() {
      const years = [];

      for (let y = this.startYear; y <= this.stopYear; y++) {
        const year = moment(`${y}`, 'YYYY');
        const yearBeginning = moment(`${y}-01-01`);
        const yearEnd = moment(`${y}-12-31`);

        years.push({
          id: year.year(),
          text: year.year(),
          description: `${TimeUtils.format_date(yearBeginning)} -  ${TimeUtils.format_date(yearEnd)}`,
        });
      }

      return years;
    },
    selected: {
      get() {
        // modelValue wins when the parent uses Vue 3 v-model. `value` still has a default, so it is
        // always defined and cannot be used to detect "parent did not pass a year".
        const year = this.modelValue !== undefined ? this.modelValue : this.value;
        const numeric = Number(year);

        return Number.isNaN(numeric) ? year : numeric;
      },
      set(newYear) {
        this.emitModelCompatValue(newYear);
      },
    },
  },
  methods: {
    yearTemplate(state, _container) {
      return $(`
        <span>
          <span>${state.text}</span>
          <sub class="description">${state.description}</sub>
        </span>`);
    },
  },
};
</script>
